import {
    View,
    SpinnerView,
} from 'ckeditor5';

import { createApi } from 'unsplash-js';

import PhotoResultView from './photoResultView.js'
import SearchFormView from './searchFormView.js';

import '../../theme/unsplash.css';

/**
 * The unsplash photo picker view controller class.
 *
 * See {@link module:unsplash/ui/pickerView~PickerView}.
 *
 * @extends module:ui/view~View
 */
export default class PickerView extends View {
    imageTiles;

    constructor(locale, model, config) {
        super( locale );

        if(!config) throw new Error("Missing unsplash config settings");

        this.imageTiles = this.createCollection();
        this.imageTiles.add(this._createParagraph("Use the search box above to find images to insert into the editor."))

        const formView = this._createFormView( model, config );

        const listView = new View( locale );
        listView.setTemplate({
            tag: 'ul',
            attributes: {
                class: 'ck-unsplash-results',
            },
            children: this.imageTiles,
        })

        this.setTemplate({
            tag: 'div',
            attributes: {
                class: 'ck-unsplash-results-container',
            },
            children: [
                formView,
                listView,
            ]
        })

    }

    _createFormView( model, config ) {
        const locale = this.locale;
        const t = locale.t;
        const formView = new SearchFormView( locale );
        
        this.listenTo( formView, 'submit', async () => {
			const query = formView.searchField.fieldView.element?.value;
            if (!query) return 

            const token = config.token;

            const unsplash = createApi({ 
                apiUrl: `${config.apiUrl}unsplash`,
                headers: {
                    "authorization": `Bearer ${token}`,
                }
            })

            let results = [];

            // Clean up
            [...this.imageTiles].forEach( item => {
                this.imageTiles.remove(item)
            })

            const spinner = new SpinnerView();
            spinner.set( { isVisible: true })

            this.imageTiles.add(spinner)

            await unsplash.search.getPhotos(
                {
                    perPage: 30,
                    query: query
                }
            ).then(response => {
                if (response.errors) {
                    console.log("Search Error: ", response.errors[0]);
                } else {
                    results = response.response.results
                }

                this._updateGrid( results, model, config )
            }).catch(() => {
                // Clean up
                [...this.imageTiles].forEach( item => {
                    this.imageTiles.remove(item)
                })
                this.imageTiles.add(this._createParagraph( t( 'Failed to fetch results. Please try again.' ) ))
            })
        })

        return formView;
    }

    /**
	 * Creates a text paragraph view.
	 *
	 * @private
	 * @returns {module:ui/view~View} Paragraph view instance.
	 */
    _createParagraph( text ) {
        const view = new View( this.locale );

        view.setTemplate({
            tag: 'p',
            attributes: {
                class: 'ck-unsplash-paragraph',
            },
            children: [ text ]
        })

        return view;
    }

    _updateGrid( items, model, config ) {
        const t = this.locale.t;

        // Clean up
        [ ...this.imageTiles ].forEach( item => {
            this.imageTiles.remove(item);
        })

        if ( items.length > 0 ) {
            items
                .map( item => this._createImageButton( item, model, config ))
                .forEach( item => this.imageTiles.add( item ));
        } else {
            this.imageTiles.add(this._createParagraph( t('There are no results for this query, please use a different search term.') ))
        }
    }

    _createImageButton( image, model, config ) {
        const imageButtonView = new PhotoResultView( this.locale, model, config, image );
        const view = new View( this.locale );

        view.setTemplate({
            tag: 'li',
            attributes: {
                style: {
                    width: "140px",
                    height: "140px",
                    listStyle: "none"
                }
            },
            children: [
                imageButtonView
            ], 
        })

        return view;
    }
}